module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921040834_T.32b315f0.jpg";